/* eslint-disable max-len */
import React from 'react';
import { Frame, SageClassnames, Link } from '@kajabi/sage-react';

import { useCheckout } from '../../context';

const PRIVACY_LINK = (
  <Link
    href="https://kajabi.com/policies/privacy"
    style={Link.COLORS.PRIMARY}
    target="_blank"
    small
  >
    Privacy Policy
  </Link>
);

const TERMS_LINK = (
  <Link href="https://kajabi.com/terms" style={Link.COLORS.PRIMARY} target="_blank" small>
    Terms of Service
  </Link>
);

export const TermsAndConditions = () => {
  const {
    isTwoStepsSignupFirstStep,
    planInfo: { terms_and_conditions: text },
  } = useCheckout();

  const withText = () => {
    if (isTwoStepsSignupFirstStep()) {
      return (
        <p
          className={[
            SageClassnames.TYPE.BODY_SMALL_BOLD,
            SageClassnames.TYPE_COLORS.CHARCOAL_400,
          ].join(' ')}
        >
          Kajabi will use your data to enhance your experience and to send you information. You can
          change your communication preferences anytime. We may use your data as described in our{' '}
          {PRIVACY_LINK}. By clicking &quot;Continue&quot;, you agree to our {TERMS_LINK} and
          acknowledge that you have read our Privacy Policy.
        </p>
      );
    }

    return (
      <p
        className={[
          SageClassnames.TYPE.BODY_SMALL_BOLD,
          SageClassnames.TYPE_COLORS.CHARCOAL_400,
          SageClassnames.TYPE_ALIGN_CENTER,
        ].join(' ')}
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: text }}
      />
    );
  };

  return <Frame>{withText()}</Frame>;
};
